export const BoldText = (chunks: React.ReactNode) => <b>{chunks}</b>;
